// This little wrapper is required because `use-view-transitions` doesn't add the "use client" directive:
'use client';

import { EnableNextAppRouterViewTransitions } from 'use-view-transitions/next';

export default function SetupViewTransitions() {
  return <EnableNextAppRouterViewTransitions />;
}
